import { render } from "./app-system-menu.vue?vue&type=template&id=2233d114&scoped=true&ts=true"
import script from "./app-system-menu.vue?vue&type=script&lang=ts"
export * from "./app-system-menu.vue?vue&type=script&lang=ts"

import "./app-system-menu.vue?vue&type=style&index=0&id=2233d114&lang=scss&scoped=true"

import exportComponent from "D:\\shine\\shine-project\\dispatch-big-screen-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2233d114"]])

export default __exports__